/*
 * Planner Messages
 *
 * This contains all the text for the Planner component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  meeting: {
    id: 'app.components.Planner.Students.meeting',
    defaultMessage: 'Meeting',
  },
  meetings: {
    id: 'app.components.Planner.Students.meetings',
    defaultMessage: 'Meetings',
  },
  select: {
    id: 'app.components.Checklist.select',
    defaultMessage: 'Select/Deselect all',
  },
  options: {
    id: 'app.components.Planner.Students.options',
    defaultMessage: 'Who can plan the meeting?',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Next',
  },
  hasMeetings: {
    id: 'app.components.Planner.Students.hasMeetings',
    defaultMessage: 'Cannot uncheck, first remove reserved slots in step 4',
  },
  meetingLocationType: {
    id: 'app.components.Planner.meetingLocationType',
    defaultMessage: 'Location',
  },
  savePrompt: {
    id: 'app.components.Planner.Students.savePrompt',
    defaultMessage: 'Save Planning?',
  },
});
